import React, { useCallback, } from 'react'
import List from '../../grid.component';
import { AddresssHandler, CreditHandler, DateHandler, TransactionHash } from '../service';

const EnergyTransactionsGrid = ((props) => {

  const handleHash = useCallback((data) => () => {
    window.open(data.url)
  }, [])
  const energyTransactionHandler = useCallback((data) => {
    return <TransactionHash data={data?.dataItem} handleHash={handleHash} />
  }, [])
  const addressHandler = useCallback((data) => {
    return <AddresssHandler data={data?.dataItem} />
  }, [])
  const creditHandler = useCallback((data) => {
    return <CreditHandler data={data?.dataItem} />
  }, [])
  const dateHandler = useCallback((data) => {
    return <DateHandler data={data?.dataItem} />
  }, [])
  const statusHandler = useCallback((data) => {
    return <StatusHandler data={data?.dataItem} />
  }, [])
  const customcells = {
    "transactionhash": energyTransactionHandler,
    "address": addressHandler,
    "credits": creditHandler,
    "date": dateHandler,
    "status": statusHandler,
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells])

  return (
    <div>
      <List
        url={process.env.REACT_APP_API_END_POINT + `/api/v1/energy/transactions`}
        additionalParams={props?.filterValues}
        pSize={10}
        className="custom-grid"
        showExcelExport={props?.isExcelExport}
        pKey={"Energy_Recharge_Transactions"}
        screenName={'Energy_Recharge_Transactions'}
        renderCustomCell={renderCustomCell}
      />
    </div>
  )
})

export default React.memo(EnergyTransactionsGrid)
